export let Variant = /*#__PURE__*/function (Variant) {
  Variant["AcquisitionNewsletterPopup"] = "acquisition-newsletter-popup";
  Variant["Article"] = "article";
  Variant["ArticleDark"] = "article-dark";
  Variant["Footer"] = "footer";
  Variant["Homepage"] = "homepage";
  Variant["LiveArticle"] = "live-article";
  Variant["NewsletterArticle"] = "newsletter-article";
  Variant["NewsletterArticleBottom"] = "newsletter-article-bottom";
  Variant["NewsletterList"] = "newsletter-list";
  Variant["Posties"] = "posties";
  Variant["Topic"] = "topic";
  return Variant;
}({});
export let DisplayComponent = /*#__PURE__*/function (DisplayComponent) {
  DisplayComponent["FindOutMore"] = "find-out-more";
  DisplayComponent["SignUpNewsletter"] = "sign-up-newsletter";
  DisplayComponent["SignUpSuccessMessage"] = "sign-up-success-message";
  return DisplayComponent;
}({});